import { useParams } from 'react-router-dom'
import Page from '../../components/layouts/page'
import { useQuery } from '@tanstack/react-query'
import { Icon, Tag } from '@bitcine/cinesend-theme/dist'
import Snapshots from './snapshots'
import ProgressCard from '../../components/dashboard/progress_card'
import DataSizeCard from '../../components/dashboard/data_size_card'
import DataCard from '../../components/dashboard/data_card'
import isEmpty from '../../helpers/is_empty'
import CycleIsValidatingTag from '../../components/cycles_table/validation_status_tag'

const Dashboard = () => {
  const { airlineID, cycleID } = useParams()
  const { data: airline } = useQuery(['airlines/', airlineID])
  const { data: cycle, error, isLoading } = useQuery(['cycles/', cycleID])

  return (
    <Page title='Dashboard' pending={isLoading} error={error || isEmpty(cycle)}>
      <div className='flex flex-col  h-full  '>
        <DataCard className='w-full flex-col mb-3 py-8'>
          <div className='w-full flex items-center justify-center space-x-3'>
            <Icon icon='airplane_ticket' className='text-4xl' />
            <div className='font-semibold text-xl'>{airline?.name}</div>
          </div>
          <div className='w-full flex items-center justify-center space-x-3'>
            <div className='font-medium text-base'>
              {cycle?.name} - {cycle?.description}
            </div>
            <Tag label={cycle?.status_label} type='info' />
            <CycleIsValidatingTag is_validating={cycle?.is_validating} />
          </div>
        </DataCard>

        <div className='flex flex-col gap-3 w-full'>
          <DataSizeCard cycleID={cycleID} />
          <ProgressCard cycleID={cycleID} />
        </div>
      </div>
      <Snapshots cycleID={cycleID} hasErrors={cycle?.has_errors} />
    </Page>
  )
}

export default Dashboard
